var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 49 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M23.6203 35.492C21.3183 35.574 18.7283 35.0154 16.549 34.3136C12.4433 32.9915 5.73718 30.5895 3 29.5869C4.71036 28.9049 8.4078 27.6032 11.4375 26.5625M16.8423 34.4599C15.5665 37.0878 14.3675 39.6487 13.7025 41.1958C15.8029 40.2216 20.8786 37.88 24.5625 36.0625M24.5625 36.0625V44.3125M24.5625 36.0625V35.5M18.4327 21.3903C14.5919 19.7001 8.30748 17.1589 5.47113 16.1491C6.90164 18.6012 10.4395 24.5702 12.6956 28.119C14.7153 31.2961 17.8526 34.925 21.0582 35.1789M37.625 26.5C40.6701 27.5455 44.3557 28.9015 46.0748 29.5869C43.3376 30.5895 36.6315 32.9915 32.5257 34.3136C30.4197 34.9919 27.9301 35.5363 25.6875 35.4981M32.0856 34.4121C33.3489 37.0159 34.5328 39.5457 35.192 41.0792C33.0031 40.0639 28.2132 37.8037 24.4513 35.9389M30.6421 21.3903C34.4829 19.7001 40.7673 17.1589 43.6036 16.1491C42.1731 18.6012 38.6353 24.5702 36.3792 28.119C34.1476 31.6293 30.5518 35.6912 27.0069 35.1429M24.5 3C23.3333 6.33333 20.5384 14.5 19 19.5C17 26 16 35.5 24.5 35.5C33 35.5 31.7771 25.4238 30 19.5C28.5 14.5 25.8333 6.5 24.5 3Z",
          stroke: "#41C195",
          "stroke-width": "1.5",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }